import type {
  FieldMappingScreen,
  StandardEntityAttributes,
  FieldMappingGenericError,
  StandardEntityDesignationResponse,
  UpdateStandardEntityDesignationData,
  Designation,
} from 'src/types/field-mapping';
import type {Dispatch, ThunkAction, GetState} from 'src/reducers';
import {thunkify as flow} from 'src/utils/thunks';
import {key, fetching} from 'src/utils/redux';
import {cloneDesignationsResponse} from 'src/utils/field-mapping';
import * as reduxApi from 'src/utils/redux-api-v2';


const DEFAULT_ERROR: FieldMappingGenericError = {
  errorMsg: 'Some Error occoured',
};

export type FieldMappingAction =
  | UpdateActiveFieldMappingScreenAction
  | StandardEntityAction
  | StandardEntityLoadingAction
  | StandardEntityErrorAction;

/**
 * Action Name constants definition starts here.
 */

export const UPADTE_ACTIVE_FIELD_MAPPING_SCREEN =
  'fieldMapping/updateActiveScreen';

export const SET_STANDARD_ENTITY_DESIGNATION =
  'field-mapping/set-standard-entity-designations';
export const STANDARD_ENTITY_DESIGNATION_LOADING =
  'field-mapping/standad-entity-designations-loading';
export const STANDARD_ENTITY_DESIGNATION_ERROR =
  'field-mapping/standad-entity-designations-error';
export const SET_LOCAL_STANDARD_ENTITY_DESIGNATION =
  'field-mapping/set-local-standard-entity-designations';

export const SET_STANDARD_ENTITY = 'field-mapping/set-standard-entity';
export const STANDARD_ENTITY_LOADING = 'field-mapping/standad-entity-loading';
export const STANDARD_ENTITY_ERROR = 'field-mapping/standad-entity-error';

export const SAVE_STANDARD_FIELD_MAPPING_LOADING =
  'field-mapping/save-standard-field-mapping-loading';
export const SAVE_STANDARD_FIELD_MAPPING_SUCCESS =
  'field-mapping/save-standard-field-mappin-success';
export const SAVE_STANDARD_FIELD_MAPPING_ERROR =
  'field-mapping/save-standard-field-mappin-error';

export const CONFIRM_MIGRATE_FIELD_MAPPING_LOADING =
  'field-mapping/confirm-migrate-field-mapping-loading';

export const CONFIRM_MIGRATE_FIELD_MAPPING_SUCCESS =
  'field-mapping/confirm-migrate-field-mapping-success';
export const CONFIRM_MIGRATE_FIELD_MAPPING =
  'field-mapping/confirm-migrate-field-mapping';
export const CONFIRM_MIGRATE_FIELD_MAPPING_ERROR =
  'field-mapping/confirm-migrate-field-mapping-error';

/**
 * Action type definition starts here.
 */

type UpdateActiveFieldMappingScreenAction = {
  type: 'fieldMapping/updateActiveScreen';
  payload: FieldMappingScreen;
};

type SaveStandardFieldMappingLoadingAction = {
  type: typeof SAVE_STANDARD_FIELD_MAPPING_LOADING;
};

type SaveStandardFieldMappingErrorAction = {
  type: typeof SAVE_STANDARD_FIELD_MAPPING_ERROR;
  payload: FieldMappingGenericError | null | undefined;
};

type StandardEntityDesignationLoadingAction = {
  type: typeof STANDARD_ENTITY_DESIGNATION_LOADING;
};
type StandardEntityDesignationErrorAction = {
  type: typeof STANDARD_ENTITY_DESIGNATION_ERROR;
  payload: FieldMappingGenericError | null | undefined;
};

type StandardEntityDesignationAction = {
  type: typeof SET_STANDARD_ENTITY_DESIGNATION;
  payload: StandardEntityDesignationResponse;
};
type LocalStandardEntityDesignationAction = {
  type: typeof SET_LOCAL_STANDARD_ENTITY_DESIGNATION;
  payload: StandardEntityDesignationResponse;
};

type StandardEntityLoadingAction = {
  type: typeof STANDARD_ENTITY_LOADING;
};

type StandardEntityErrorAction = {
  type: typeof STANDARD_ENTITY_ERROR;
  payload: FieldMappingGenericError | null | undefined;
};

type StandardEntityAction = {
  type: typeof SET_STANDARD_ENTITY;
  payload: StandardEntityAttributes;
};

type ConfirmMigrateFieldMappingLoadingAction = {
  type: typeof CONFIRM_MIGRATE_FIELD_MAPPING_LOADING;
};

type ConfirmMigrateFieldMappingSuccessAction = {
  type: typeof CONFIRM_MIGRATE_FIELD_MAPPING_SUCCESS;
};

type ConfirmMigrateFiledMappingErrorAction = {
  type: typeof CONFIRM_MIGRATE_FIELD_MAPPING_ERROR;
  payload: FieldMappingGenericError | null | undefined;
};

/**
 * Action Definiton starts here.
 */

export const updateActiveFieldMappingScreen = (
  payload: FieldMappingScreen,
): UpdateActiveFieldMappingScreenAction => ({
  type: UPADTE_ACTIVE_FIELD_MAPPING_SCREEN,
  payload,
});

export const getStandardEntityDesignationsLoading =
  (): StandardEntityDesignationLoadingAction => ({
    type: STANDARD_ENTITY_DESIGNATION_LOADING,
  });
export const getStandardEntityDesignationsError = (
  payload?: FieldMappingGenericError | null,
): StandardEntityDesignationErrorAction => ({
  type: STANDARD_ENTITY_DESIGNATION_ERROR,
  payload,
});
export const setStandardEntityDesignations = (
  payload: StandardEntityDesignationResponse,
): StandardEntityDesignationAction => ({
  type: SET_STANDARD_ENTITY_DESIGNATION,
  payload,
});
export const setLocalStandardEntityDesignations = (
  payload: StandardEntityDesignationResponse,
): LocalStandardEntityDesignationAction => ({
  type: SET_LOCAL_STANDARD_ENTITY_DESIGNATION,
  payload,
});

export const getStandardEntityLoading = (): StandardEntityLoadingAction => ({
  type: STANDARD_ENTITY_LOADING,
});

export const getStandardEntityError = (
  payload?: FieldMappingGenericError | null,
): StandardEntityErrorAction => ({
  type: STANDARD_ENTITY_ERROR,
  payload,
});

export const setStandardEntity = (
  payload: StandardEntityAttributes,
): StandardEntityAction => ({
  type: SET_STANDARD_ENTITY,
  payload,
});

export const saveStandardFieldMappingLoading =
  (): SaveStandardFieldMappingLoadingAction => ({
    type: SAVE_STANDARD_FIELD_MAPPING_LOADING,
  });
export const saveStandardFiledMappingSuccess = (
  payload?: FieldMappingGenericError | null,
): SaveStandardFieldMappingErrorAction => ({
  // @ts-expect-error - TS2322 - Type '"field-mapping/save-standard-field-mappin-success"' is not assignable to type '"field-mapping/save-standard-field-mappin-error"'.
  type: SAVE_STANDARD_FIELD_MAPPING_SUCCESS,
  payload,
});
export const saveStandardFiledMappingError = (
  payload?: FieldMappingGenericError | null,
): SaveStandardFieldMappingErrorAction => ({
  type: SAVE_STANDARD_FIELD_MAPPING_ERROR,
  payload,
});

export const confirmMigrateFieldMappingLoading =
  (): ConfirmMigrateFieldMappingLoadingAction => ({
    type: CONFIRM_MIGRATE_FIELD_MAPPING_LOADING,
  });
export const confirmMigrateFieldMappingSuccess =
  (): ConfirmMigrateFieldMappingSuccessAction => ({
    type: CONFIRM_MIGRATE_FIELD_MAPPING_SUCCESS,
  });

export const confirmMigrateFiledMappingError = (
  payload?: FieldMappingGenericError | null,
): ConfirmMigrateFiledMappingErrorAction => ({
  // @ts-expect-error - TS2322 - Type '"field-mapping/save-standard-field-mappin-error"' is not assignable to type '"field-mapping/confirm-migrate-field-mapping-error"'.
  type: SAVE_STANDARD_FIELD_MAPPING_ERROR,
  payload,
});

export const updateLocalStandardEntityDesignation =
  (payload: UpdateStandardEntityDesignationData): ThunkAction =>
  (dispatch: Dispatch, getState: GetState) => {
    const {
      standard_entity_type,
      designation_name,
      entity_attribute_name,
      entity_attribute_id,
    } = payload;
    const localStandardEntityDesignations: StandardEntityDesignationResponse =
      getState().fieldMapping?.localStandardEntityDesignation;

    for (const standardEntityDesignationObj of localStandardEntityDesignations) {
      if (
        standardEntityDesignationObj.standard_entity_type ===
        standard_entity_type
      ) {
        const designations: Designation[] =
          standardEntityDesignationObj.designations;
        for (const designation of designations) {
          if (designation.designation_name === designation_name) {
            designation.entity_attribute_name = entity_attribute_name;
            designation.entity_attribute_id = entity_attribute_id;
            break;
          }
        }
        break;
      }
    }

    return dispatch(
      // @ts-expect-error - TS2769 - No overload matches this call.
      setLocalStandardEntityDesignations(localStandardEntityDesignations),
    );
  };

export const resetLocalStandardEntityDesignations =
  (): ThunkAction<void> =>
  async (dispatch: Dispatch, getState: GetState): Promise<void> => {
    const standardEntityDesignations: StandardEntityDesignationResponse =
      getState().fieldMapping?.standardEntityDesignationResponse;
    const clonedDesignationsResponse = cloneDesignationsResponse(
      standardEntityDesignations,
    );
    // @ts-expect-error - TS2769 - No overload matches this call.
    dispatch(setLocalStandardEntityDesignations(clonedDesignationsResponse));
  };

export const fetchStandardEntityDesignations: () => ThunkAction<void> = flow(
  key(() => 'entity_attributes/standard/designations'),
  fetching(),
)(() => (dispatch: Dispatch) => {
  // @ts-expect-error - TS2769 - No overload matches this call.
  dispatch(getStandardEntityDesignationsLoading());
  return dispatch(reduxApi.get(`entity_attributes/standard/designations`)).then(
    (response: StandardEntityDesignationResponse) => {
      // @ts-expect-error - TS2769 - No overload matches this call.
      dispatch(setStandardEntityDesignations(response));
    },
    (error) => {
      dispatch(
        // @ts-expect-error - TS2769 - No overload matches this call.
        getStandardEntityDesignationsError(
          error?.response?.errors || DEFAULT_ERROR,
        ),
      );
    },
  );
});

export const fetchStandardEntity: () => ThunkAction<void> = flow(
  key(() => 'entity_attributes/standard/attributes'),
  fetching(),
)(() => (dispatch: Dispatch) => {
  dispatch(getStandardEntityLoading());
  return dispatch(reduxApi.get(`entity_attributes/standard/attributes`)).then(
    (response: StandardEntityAttributes) => {
      dispatch(setStandardEntity(response));
    },
    (error) => {
      dispatch(
        getStandardEntityError(error?.response?.errors || DEFAULT_ERROR),
      );
    },
  );
});

export const saveStandardFieldMapping =
  (migrate: boolean): ThunkAction<void> =>
  (dispatch: Dispatch, getState: GetState) => {
    const standardEntityDesignations: StandardEntityDesignationResponse =
      getState().fieldMapping?.localStandardEntityDesignation;
    // @ts-expect-error - TS2769 - No overload matches this call.
    dispatch(saveStandardFieldMappingLoading());
    const url = 'entity_attributes/standard/designations';

    return dispatch(
      reduxApi.post(url, {standard_designations: standardEntityDesignations}),
    ).then(
      (response) => {
        // @ts-expect-error - TS2769 - No overload matches this call.
        dispatch(saveStandardFiledMappingSuccess());
        if (migrate === true) {
          dispatch(updateActiveFieldMappingScreen('Confirm'));
        }
        // @ts-expect-error - TS2769 - No overload matches this call.
        dispatch(setStandardEntityDesignations(response));
      },
      (error) => {
        dispatch(
          // @ts-expect-error - TS2769 - No overload matches this call.
          saveStandardFiledMappingError(
            error?.response?.errors || DEFAULT_ERROR,
          ),
        );
      },
    );
  };

export const confirmMigrationFieldMapping =
  (): ThunkAction<void> => (dispatch: Dispatch, getState: GetState) => {
    const standardEntityDesignations: StandardEntityDesignationResponse =
      getState().fieldMapping?.localStandardEntityDesignation;
    // @ts-expect-error - TS2769 - No overload matches this call.
    dispatch(confirmMigrateFieldMappingLoading());

    const url = 'entity_attributes/field_mapping/confirm_migration';
    return dispatch(
      reduxApi.post(url, {standard_designations: standardEntityDesignations}),
    ).then(
      (response) => {
        // @ts-expect-error - TS2769 - No overload matches this call.
        dispatch(confirmMigrateFieldMappingSuccess());
        return response;
      },
      (error) => {
        dispatch(
          // @ts-expect-error - TS2769 - No overload matches this call.
          confirmMigrateFiledMappingError(
            error?.response?.errors || DEFAULT_ERROR,
          ),
        );
      },
    );
  };
